export var invokeAdminToolsUI = function invokeAdminToolsUI() {
  window.dispatchEvent(new CustomEvent('prezi:admin:tools:invoke'));
};
export var listenToAdminToolsTagStatusEvent = function listenToAdminToolsTagStatusEvent(onTagStatusUpdated) {
  window.addEventListener('prezi:admin:tools:hidden:tags:loaded', function (event) {
    if (!(event instanceof CustomEvent)) {
      return;
    }

    var parsedEvent = event;

    if (parsedEvent.detail.hasTags) {
      onTagStatusUpdated(true);
    } else {
      onTagStatusUpdated(false);
    }
  });
};